module.exports = __webpack_public_path__ + "static/media/end_of_lesson.eeb0d8b8.svg";